import clsx from 'clsx'
import React, { forwardRef, useMemo } from 'react'

interface MetalTierBadgeProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'className'> {
  bordered?: boolean;
  tier:
    | 'catastrophic'
    | 'bronze'
    | 'expanded_bronze'
    | 'silver'
    | 'gold'
    | 'platinum';
}

export const MetalTierBadge = forwardRef<HTMLSpanElement, MetalTierBadgeProps>(
  ({ bordered = false, tier, ...props }, forwardedRef) => {
    const { label, colorClassNames } = useMemo(() => {
      let label: string
      let colorClassNames: string
      switch (tier) {
        case 'bronze':
          label = 'Bronze'
          colorClassNames = 'bg-orange-100 border-orange-300 text-orange-500'
          break
        case 'expanded_bronze':
          label = 'Expanded bronze'
          colorClassNames = 'bg-orange-100 border-orange-300 text-orange-500'
          break
        case 'silver':
          label = 'Silver'
          colorClassNames = 'bg-gray-100 border-gray-300 text-gray-800'
          break
        case 'gold':
          label = 'Gold'
          colorClassNames = 'bg-yellow-100 border-yellow-300 text-yellow-500'
          break
        case 'platinum':
          label = 'Platinum'
          colorClassNames = 'bg-slate-50 border-slate-300 text-slate-500'
          break
        /**
         * We shouldn't be displaying catastrophic plans to ICHRA members, but
         * we have handling for it just in case.
         */
        case 'catastrophic':
        default:
          label = 'Catastrophic'
          colorClassNames = 'bg-red-50 border-red-300 text-red-500'
      }

      return { label, colorClassNames }
    }, [tier])

    return (
      <span
        {...props}
        className={clsx(
          'inline-block px-2 py-1 rounded-lg body-sm-bold',
          colorClassNames,
          { border: bordered }
        )}
        ref={forwardedRef}
      >
        {label}
      </span>
    )
  }
)
